<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="1"
              vs-sm="4"
              vs-xs="12"
            >
              <vs-button
                @click="goBack"
                color="danger"
                type="border"
                icon="keyboard_backspace"
                >Back</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="9"
              vs-sm="4"
              vs-xs="12"
            >
              <h3>Update Outcome</h3>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
            </vs-col>
          </vs-row>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Name:</span>
            </div>

            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="name"
                v-model="outcomeDescription.name"
                v-validate="'required'"
                data-vv-as="Name"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('name')"
              >{{ errors.first("name") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Description:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="description"
                v-model="outcomeDescription.description"
                v-validate="'required'"
                data-vv-as="Outcomes Description"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('description')"
              >{{ errors.first("description") }}</span
            >
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Action Type:</span>
            </div>

            <div class="vx-col sm:w-1/3 w-full">
              <v-select
                label="name"
                name="action_type"
                :options="action_types"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="outcomeDescription.action_type"
                v-validate="'required'"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('action_type')"
              >{{ errors.first("action_type") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Grade:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-checkbox class="mb-2" name="option" v-model="outcomeDescription.grade" :vs-value="'2'" >{{ 'Attempted to call' }}</vs-checkbox>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Option:</span>
            </div>

            <div class="vx-col sm:w-1/3 w-full">
              <div v-for="(option, index) in options" :key="index">
                <vs-checkbox
                  class="mb-2"
                  name="option"
                  v-model="outcomeDescription.action_type_outcome_option"
                  :vs-value="option"
                  v-validate="'required'"
                  >{{ option.name }}</vs-checkbox
                >
              </div>
              <!-- <v-select
                label="name"
                name="action_type"
                :options="action_types"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="outcomes.action_type"
                v-validate="'required'"
              /> -->
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('option')"
              >{{ errors.first("option") }}</span
            >
          </div>

          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-button class="mr-3 mb-2" @click.prevent="updateForm"
                >Submit</vs-button
              >
            </div>
          </div>
          <DataGrid :context="'ActionTypeOutcomeOption'" 
            ref="outcomes"
            :columnDefs="columnDefs"
            :rowData="records"
            :dataSource="dataSource"
          >
          </DataGrid>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
// Store Module
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import moduleOutcomeManagement from "@/store/outcome-management/moduleOutcomeManagement.js";
import vSelect from "vue-select";
export default {
  beforeMount() {
    this.getDataSource();
  },
  data() {
    return {
      options : [
        {
          slug: "next",
          name: "Next"
        }
      ],
      action_types: [],
      user_role: null,
      companySearchComponentKey: 0,
      outcomeDescription: [],
      outcome_id: null,
      chooseExistingList: false,
      columnDefs: [
        {
          headerName: "Name",
          field: "name",
          filter: "agTextColumnFilter",
          flex: 1,
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Description",
          field: "description",
          flex: 1,

          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Action Type",
          field: "action_type",
          flex: 1,

          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Option",
          field: "action_type_outcome_option",
          flex: 1,

          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Grade",
          field: "grade",
          flex: 1,

          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        }
      ],
      dataSource: {},
      records: [],
      selected: [],
      allOutcomes: [],
      abilities: null,
      existing_list_values: null,
      existing_outcomes_list: [],
      outcomes: {
        name: null,
        description: null,
        action_type: null,
        grade:null
      }
    };
  },
  components: {
    "v-select": vSelect,
    moduleOutcomeManagement,
    DataGrid
  },
  created() {
    var self = this;
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_role = userInfo["userRole"];
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    if (!moduleOutcomeManagement.isRegistered) {
      this.$store.registerModule("OutcomesManagement", moduleOutcomeManagement);
      moduleOutcomeManagement.isRegistered = true;
    }
  },
  mounted() {
    this.fetchAllActionTypes();

    this.outcome_id = this.$route.params.outcomeId;
    this.fetchOutcome();
  },
  watch: {    
    'outcomeDescription.grade'(val){
      if(val == '2'){
        this.options = [
        {
          slug: "submit",
          name: "Submit"
        },
        {
          slug: "schedule_a_next_action",
          name: "Schedule a Next Action"
        },
        {
          slug: "no_i_dont_to_schedule_a_next_action",
          name: "No, I don't want to schedule a next action"
        }
      ]
      }else{
        this.options = [
        {
          slug: "next",
          name: "Next"
        }
      ]
      }
    }},
  methods: {
    fetchAllActionTypes() {
      var self = this;
      self.$store
        .dispatch("OutcomesManagement/getAllActionTypesForOutcomes")
        .then(function(response) {
          let response_data = response.data;
          self.action_types = response_data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getDataSource() {
      var self = this;
      this.dataSource = {
        getRows(params) {
          self.$store
            .dispatch("OutcomesManagement/getAllOutcomes", params.request)
            .then(function(response) {
              let response_data = response.rows;
              if (response_data.length != 0) {
                self.$refs.outcomes.gridApi.hideOverlay();
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.outcomes.gridApi.showNoRowsOverlay();
                return params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    goBack: function() {
      this.$router.go(-1);
    },
    updateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.updateOutcomes();
        }
      });
    },
    updateOutcomes() {
      this.outcomeDescription.call_action_type_id = this.outcomeDescription.action_type.id;
      let outcome_option = []
      this.outcomeDescription.action_type_outcome_option.map(function(ele){
          outcome_option.push(ele.slug)
      })
      this.outcomeDescription.option = outcome_option
      this.$store
        .dispatch("OutcomesManagement/updateOutcomes", this.outcomeDescription)
        .then(res => {
          if (res.data.status == "fail") {
            this.$vs.notify({
              color: "danger",
              title: "Outcomes Exists",
              text: res.data.message
            });
          } else {
            this.$vs.notify({
              color: "success",
              title: "Outcomes Added",
              text: "Theoutcomes was updated successfully"
            });
            this.$router.push({ path: "/audit_trial/outcomes" });
          }
        })
        .catch(err => {
          console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    fetchOutcome() {
      let self = this;

      this.$store
        .dispatch("OutcomesManagement/fetchOutcomes", self.outcome_id)
        .then(res => {
          let result = JSON.parse(res.data);
          self.outcomeDescription = result[0];

          self.action_types.forEach(function(ele) {
            console.log(ele.id, self.outcomeDescription.call_action_type_id);

            if (ele.id == self.outcomeDescription.call_action_type_id) {
              self.outcomeDescription.action_type = ele;
            }
          });

          let selected_option = [];

        let all_options = [
          {
          slug: "next",
          name: "Next"
        },
        {
          slug: "submit",
          name: "Submit"
        },
        {
          slug: "schedule_a_next_action",
          name: "Schedule a Next Action"
        },
        {
          slug: "no_i_dont_to_schedule_a_next_action",
          name: "No, I don't want to schedule a next action"
        }]

          

          all_options.forEach(function(ele) {
            if (
              self.outcomeDescription.action_type_outcome_option.includes(
                ele.slug
              )
            ) {
              selected_option.push(ele);
            }
          });

          console.log("slected option" , selected_option)

          self.outcomeDescription.action_type_outcome_option = selected_option;
        })
        .catch(err => {
          console.error(err);
        });
    }
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}
.removeButtonClass {
  cursor: pointer;
  position: relative;
  float: right;
  margin-top: -25px;
  margin-right: 25px;
}
</style>
